import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

const Img = styled.img`
  margin: ${props =>
    `0 ${props.rightpadded ? "10px" : 0} 4px ${props.leftpadded ? "10px" : 0}`};
  width: 15px;
  transform: ${props => `rotate(${props.rotate}deg)`};
  vertical-align: middle;
`;
Img.propTypes = {
  rightpadded: PropTypes.bool,
  leftpadded: PropTypes.bool,
  rotate: PropTypes.number.isRequired
};

const ArrowIcon = props => {
  let alt, rotate;
  switch (props.direction) {
    case "up":
      alt = "&uarr;";
      rotate = 90;
      break;
    case "down":
      alt = "&darr;";
      rotate = 270;
      break;
    case "right":
      alt = "&rarr;";
      rotate = 180;
      break;
    case "left":
    default:
      alt = "&larr;";
      rotate = 0;
      break;
  }

  return (
    <Img
      src="/assets/images/icon--arrow.svg"
      alt={alt}
      {...{ ...props, rotate }}
    />
  );
};
ArrowIcon.propTypes = {
  direction: PropTypes.oneOf(["up", "down", "left", "right"])
};
ArrowIcon.defaultProps = {
  direction: "left"
};

export default ArrowIcon;
